import styled from 'styled-components';

export const EmptyBodyTable = styled.div`
	align-items: center;
	align-self: center;
	display: flex;
	flex-direction: column;
	gap: 12px;
	justify-content: center;
	justify-self: center;
	margin-top: 40px;
	padding: 12px;
	text-align: center;
	width: 288px;
`;

export const ContainerText = styled.div`
	display: flex;
	flex-direction: column;
`;

export const EmptyBodyTableText = styled.h3`
	color: ${({ theme }) => theme.colors.principal.abell};
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 28px;
`;

export const EmptyBodyTableSecondText = styled.p`
	color: ${({ theme }) => theme.colors.extra.space_700};
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 110%;
`;
